import entityContainerConnector from '~components/generic/entityContainerConnector';
import SidebarHeader from '~components/sidebar/header/SidebarHeader';

export default entityContainerConnector(SidebarHeader);
